import moment from 'moment'

const aNumRules = value => {
  if (!value) return true

  let isValid = false
  const digitLength = value.replace(/\s/g, '').replace(/-/g, '').length

  // The character-check is only relevant if *not* using text-mask, due
  // to displaying old characters.
  // If any letters are loaded from before, don't consider valid
  // If not using text-mask, still consider valid with any spaces or hyphens, but they will get removed when saving
  if (value.length === 0 || (/^[\d\s-]+$/.test(value) && digitLength === 9)) isValid = true

  const errorMessage = 'A-number not valid'

  return isValid || errorMessage
}

const ssnRules = value => {
  if (!value) return true
  return /^[\d]{9}|[\d]{3}-[\d]{2}-[\d]{4}$/.test(value) || 'SSN not valid'
}

const maxChars = (maxNum, v) => { return (v || '').length <= maxNum || `Max ${maxNum} chars` }

const passwordMinLength = value => (value || '').length >= 16 || 'Must be at least 16 characters'

const passwordHasNumber = value => /\d/.test(value || '') || 'Must contain at least one number'

const passwordHasSpecialChar = value => /[^a-zA-Z0-9]/.test(value || '') || 'Must contain at least one special character'

const passwordNoLeadingOrTrailingSpace = value => (value || '') === (value || '').trim() || 'Must not start or end with a space'

const domesticPhoneNumber = value => {
  return !(/^\d{10}$/.test(value) || /^\(\d{3}\) \d{3}-\d{4}$/.test(value)) ? 'Number is invalid' : true
}

const emailAddress = value => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'Invalid email address!'

const internationalPhoneNumber = value => {
  if (!/^[-0-9()\s.]+$/.test(value)) return 'Number can only contain digits, (, ), dashes (-), dots (.), and spaces'
  if (value.length > 25) return 'Number is too long'
  return true
}

const required = value => {
  let isValid = true

  if (!value || (value && Array.isArray(value) && value.length === 0) ||
    (value && typeof value === 'string' && value.trim().length === 0)) isValid = false

  return isValid || 'Required'
}

const searchTermMin = value => {
  let stringNoSpaces = ''

  if (value) stringNoSpaces = value.replace(/ /g, '')

  return (!!value && stringNoSpaces.length > 2) || 'Search term must be at least 3 characters'
}

const zipcode = value => (!value || /^\d{5}-?(\d{4})?$/.test(value)) || 'Zip code is invalid'

const fileName = value => ((value && /^[\w\-_.() {}'~`!?@#^&*+="[\]]+$/.test(value)) || 'File name is invalid')

const in12Hour = value => ((value && /^([1-9]|0[1-9]|1[0-2])[:]?([0-5][0-9]){0,2}\s*([AP][M])?$/i.test(value)) || 'Expected format HH:MM AM/PM')

const twilioAccountSID = value => /^AC[A-Fa-f0-9]{32}$/.test(value)

const twilioAuthToken = value => /^[A-Fa-f0-9]{32}$/.test(value)

const fileSize = file => {
  const limit = 20
  let isValid = true

  if (!file || (file.size && file.size / 1024 / 1024 > limit)) isValid = false

  return isValid || `Size should be less than ${limit} MB!`
}

const startBeforeEndDate = (startDate, endDate) => {
  if (!startDate || !endDate) return true
  return moment(startDate).isBefore(endDate)
}

export const rules = {
  aNumRules,
  domesticPhoneNumber,
  emailAddress,
  fileName,
  fileSize,
  in12Hour,
  internationalPhoneNumber,
  maxChars,
  passwordHasNumber,
  passwordHasSpecialChar,
  passwordMinLength,
  passwordNoLeadingOrTrailingSpace,
  required,
  searchTermMin,
  ssnRules,
  startBeforeEndDate,
  twilioAccountSID,
  twilioAuthToken,
  zipcode,
}
